import { BrowserRouter, Route as WebRoute, Link as WebLink } from 'react-router-dom'

export let Router = BrowserRouter;
export let Route = WebRoute;
export let Link = WebLink;
